import { c as _c } from "react/compiler-runtime";
import ProductImage from '../products/ProductImage';
type AwardTier = {
  image: string | null;
  title: string;
  count: number;
};
type Props = {
  tiers: AwardTier[];
  size?: 'xs' | 'sm' | 'md';
};

// Render awards through the shared ProductImage (round mode) so they look the
// same here as in the tag modal: circular tile, like a user avatar.
const PX: Record<NonNullable<Props['size']>, number> = {
  xs: 18,
  sm: 28,
  md: 40
};
const BADGE_STYLES = {
  xs: 'h-3 min-w-3 text-[7px] -bottom-0.5 -left-0.5 px-0.5',
  sm: 'h-3.5 min-w-3.5 text-[8px] -bottom-0.5 -left-0.5 px-0.5',
  md: 'h-5 min-w-5 text-[11px] -bottom-1 -left-1 px-1'
};
const AwardBadges = t0 => {
  const $ = _c(7);
  const {
    tiers,
    size: t1
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  let t2;
  if ($[0] !== size || $[1] !== tiers) {
    let t3;
    if ($[3] !== size) {
      t3 = tier => tier.image ? <div key={tier.title} className="relative"><ProductImage imageKey={tier.image} alt={tier.title} size={PX[size]} round={true} />{tier.count > 1 && <span className={`absolute flex items-center justify-center rounded-full bg-black/60 font-semibold text-white backdrop-blur-sm ${BADGE_STYLES[size]}`}>{tier.count}</span>}</div> : null;
      $[3] = size;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = tiers.map(t3);
    $[0] = size;
    $[1] = tiers;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="flex items-center gap-1">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default AwardBadges;